import { render, staticRenderFns } from "./VerifySenderDialog.vue?vue&type=template&id=11d9bb67&"
import script from "./VerifySenderDialog.vue?vue&type=script&lang=js&"
export * from "./VerifySenderDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports